export const getCookie = (cname) => {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};

export const getLang = () => {
    let wpmlCurrentLanguage = '';

    // Get lang in front
    if (document.documentElement) {
        wpmlCurrentLanguage = document.documentElement.lang.split('-').shift() || 'en';
    }
    // Get lang in back office
    else {
        wpmlCurrentLanguage = getCookie('wp-wpml_current_language') || 'en';
    }

    return wpmlCurrentLanguage;
};
